<div class="product-statistic">
    <pf-loading-overlay />
    <div class="product-statistic__filters">
        <form
            action="statistics_filters"
            class="product-statistic__filter-form"
            [formGroup]="productStatisticsFilter"
            (submit)="updateStockingStatisticsByFilter()"
        >
            <div class="product-statistic__filter-field">
                <label for="product-event-products">{{ 'admin.product.statistics.field.productName' | translate }}:</label>
                <pf-select
                    [options]="productOptions"
                    [multiMode]="true"
                    [initialSelectedIds]="savedProductIds()"
                    (selectionChange)="onProductIdsChange($event)"
                />
            </div>
            <div class="product-statistic__filter-field">
                <label for="product-event-start-date">{{ 'admin.product.statistics.field.startDate' | translate }}:</label>
                <pf-datepicker
                    [multiMode]="true"
                    [initialStartDate]="savedStartDate()"
                    [initialEndDate]="savedEndDate()"
                    [maxDate]="maxDate"
                    (selectedStartDate)="onStartDateChange($event)"
                    (selectedEndDate)="onEndDateChange($event)"
                />
            </div>
            <div class="product-statistic__filter-field product-statistic__filter-actions">
                <button class="product-statistic__search-btn" type="submit">
                    <mat-icon>search</mat-icon>
                    <span>{{ 'admin.product.statistics.button.search' | translate }}</span>
                </button>
                <button class="product-statistic__reset-btn" type="button" (click)="onResetFilters()">
                    <mat-icon>refresh</mat-icon>
                    <span>{{ 'PRODUCT_EVENTS.RESET_FILTERS' | translate }}</span>
                </button>
            </div>
        </form>
    </div>
    @if (getStockingStatisticsResponse) {
        @if (totalItems() > 0) {
            <pf-pagination
                [requestedPage]="page()"
                [requestedPageSize]="size()"
                [totalItems]="totalItems()"
                (pageChanged)="onPageChanged($event)"
            />
        }
        <div class="product-statistic__grid-container">
            <div class="product-statistic__grid">
                <div class="product-statistic__grid-header">
                    <div class="product-statistic__grid-column">{{ 'admin.product.statistics.field.productName' | translate }}</div>
                    <div class="product-statistic__grid-column">{{ 'admin.product.statistics.field.printed' | translate }}</div>
                    <div class="product-statistic__grid-column">{{ 'admin.product.statistics.field.office' | translate }}</div>
                    <div class="product-statistic__grid-column">{{ 'admin.product.statistics.field.warehouse' | translate }}</div>
                    <div class="product-statistic__grid-column">{{ 'admin.product.statistics.field.delegated' | translate }}</div>
                    <div class="product-statistic__grid-column">{{ 'admin.product.statistics.field.stayedInDelegation' | translate }}</div>
                    <div class="product-statistic__grid-column">{{ 'admin.product.statistics.field.soldFromDelegation' | translate }}</div>
                    <div class="product-statistic__grid-column">{{ 'admin.product.statistics.field.sold' | translate }}</div>
                    <div class="product-statistic__grid-column">{{ 'admin.product.statistics.field.soldOnWeb' | translate }}</div>
                    <div class="product-statistic__grid-column">{{ 'admin.product.statistics.field.scrapped' | translate }}</div>
                    <div class="product-statistic__grid-column">{{ 'admin.product.statistics.field.giveaway' | translate }}</div>
                    <div class="product-statistic__grid-column">{{ 'admin.product.statistics.field.total' | translate }}</div>
                </div>
                <div class="product-statistic__grid-body">
                    @for (statistic of getStockingStatisticsResponse.productStatisticsList; track $index; let i = $index) {
                        <div
                            class="product-statistic__grid-row"
                            [class.product-statistic__grid-row--clickable]="
                                statistic.productStatisticsPerPartnerList?.length || statistic.productStatisticsPerFestivalList?.length
                            "
                            [class.product-statistic__grid-row--selected]="selectedRowIndex() === i"
                            [tabindex]="
                                statistic.productStatisticsPerPartnerList?.length || statistic.productStatisticsPerFestivalList?.length
                                    ? 0
                                    : -1
                            "
                            (click)="
                                statistic.productStatisticsPerPartnerList?.length || statistic.productStatisticsPerFestivalList?.length
                                    ? selectRow(i)
                                    : null
                            "
                            (keydown.enter)="
                                statistic.productStatisticsPerPartnerList?.length || statistic.productStatisticsPerFestivalList?.length
                                    ? selectRow(i)
                                    : null
                            "
                        >
                            <div class="product-statistic__grid-cell">{{ statistic.productName }}</div>
                            <div class="product-statistic__grid-cell">{{ statistic.printedQuantity | number: '1.0-0' : 'hu-HU' }}</div>
                            <div class="product-statistic__grid-cell">{{ statistic.officeQuantity | number: '1.0-0' : 'hu-HU' }}</div>
                            <div class="product-statistic__grid-cell">{{ statistic.warehouseQuantity | number: '1.0-0' : 'hu-HU' }}</div>
                            <div class="product-statistic__grid-cell">{{ statistic.delegatedQuantity | number: '1.0-0' : 'hu-HU' }}</div>
                            <div class="product-statistic__grid-cell">
                                {{ statistic.stayedInDelegationQuantity | number: '1.0-0' : 'hu-HU' }}
                            </div>
                            <div class="product-statistic__grid-cell">
                                {{ statistic.soldFromDelegationQuantity | number: '1.0-0' : 'hu-HU' }}
                            </div>
                            <div class="product-statistic__grid-cell">{{ statistic.soldQuantity | number: '1.0-0' : 'hu-HU' }}</div>
                            <div class="product-statistic__grid-cell">{{ statistic.soldOnWebQuantity | number: '1.0-0' : 'hu-HU' }}</div>
                            <div class="product-statistic__grid-cell">{{ statistic.scrappedQuantity | number: '1.0-0' : 'hu-HU' }}</div>
                            <div class="product-statistic__grid-cell">{{ statistic.giveAwayQuantity | number: '1.0-0' : 'hu-HU' }}</div>
                            <div class="product-statistic__grid-cell">
                                {{ statistic.totalQuantity | number: '1.0-0' : 'hu-HU' }}
                            </div>
                        </div>
                        @if (
                            statistic.expanded &&
                            (statistic.productStatisticsPerPartnerList?.length || statistic.productStatisticsPerFestivalList?.length)
                        ) {
                            <div class="product-statistic__expanded" tabindex="0">
                                @if (statistic.productStatisticsPerPartnerList?.length) {
                                    <div class="product-statistic__partner-details">
                                        <div class="product-statistic__expanded-title">
                                            <mat-icon>warehouse</mat-icon>
                                            <span>{{ 'admin.product.statistics.detail.perPartnerTitle' | translate }}</span>
                                        </div>
                                        <div class="product-statistic__grid">
                                            <div class="product-statistic__grid-header">
                                                <div class="product-statistic__grid-column">
                                                    {{ 'admin.product.statistics.field.partnerName' | translate }}
                                                </div>
                                                <div class="product-statistic__grid-column">
                                                    {{ 'admin.product.statistics.detail.delegated' | translate }}
                                                </div>
                                                <div class="product-statistic__grid-column">
                                                    {{ 'admin.product.statistics.detail.partnerStock' | translate }}
                                                </div>
                                                <div class="product-statistic__grid-column">
                                                    {{ 'admin.product.statistics.detail.soldFromDelegation' | translate }}
                                                </div>
                                                <div class="product-statistic__grid-column">
                                                    {{ 'admin.product.statistics.detail.soldToPartner' | translate }}
                                                </div>
                                                <div class="product-statistic__grid-column">
                                                    {{ 'admin.product.statistics.detail.returned' | translate }}
                                                </div>
                                            </div>
                                            <div class="product-statistic__grid-body product-statistic__grid-row--detail">
                                                @for (
                                                    perpartner of statistic.productStatisticsPerPartnerList;
                                                    track $index;
                                                    let i = $index
                                                ) {
                                                    <div class="product-statistic__grid-row">
                                                        <div class="product-statistic__grid-cell">{{ perpartner.partnerName }}</div>
                                                        <div class="product-statistic__grid-cell">
                                                            {{ perpartner.delegatedQuantity | number: '1.0-0' : 'hu-HU' }}
                                                        </div>
                                                        <div class="product-statistic__grid-cell">
                                                            {{ perpartner.stockQuantity | number: '1.0-0' : 'hu-HU' }}
                                                        </div>
                                                        <div class="product-statistic__grid-cell">
                                                            {{ perpartner.soldFromDelegationQuantity | number: '1.0-0' : 'hu-HU' }}
                                                        </div>
                                                        <div class="product-statistic__grid-cell">
                                                            {{ perpartner.soldToPartnerQuantity | number: '1.0-0' : 'hu-HU' }}
                                                        </div>
                                                        <div class="product-statistic__grid-cell">
                                                            {{ perpartner.returnedFromDelegationQuantity | number: '1.0-0' : 'hu-HU' }}
                                                        </div>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                }
                                @if (statistic.productStatisticsPerFestivalList?.length) {
                                    <div class="product-statistic__festival-details">
                                        <div class="product-statistic__expanded-title">
                                            <mat-icon>storefront</mat-icon>
                                            <span>{{ 'admin.product.statistics.detail.perFestivalTitle' | translate }}</span>
                                        </div>
                                        <div class="product-statistic__grid">
                                            <div class="product-statistic__grid-header">
                                                <div class="product-statistic__grid-column">
                                                    {{ 'admin.product.statistics.detail.festivalName' | translate }}
                                                </div>
                                                <div class="product-statistic__grid-column">
                                                    {{ 'admin.product.statistics.detail.movedToFestival' | translate }}
                                                </div>
                                                <div class="product-statistic__grid-column">
                                                    {{ 'admin.product.statistics.detail.soldOnFestival' | translate }}
                                                </div>
                                                <div class="product-statistic__grid-column">
                                                    {{ 'admin.product.statistics.detail.returnedFromFestival' | translate }}
                                                </div>
                                            </div>
                                            <div class="product-statistic__grid-body product-statistic__grid-row--detail">
                                                @for (
                                                    festival of statistic.productStatisticsPerFestivalList;
                                                    track $index;
                                                    let i = $index
                                                ) {
                                                    <div class="product-statistic__grid-row">
                                                        <div class="product-statistic__grid-cell">{{ festival.festivalName }}</div>
                                                        <div class="product-statistic__grid-cell">
                                                            {{ festival.movedQuantity | number: '1.0-0' : 'hu-HU' }}
                                                        </div>
                                                        <div class="product-statistic__grid-cell">
                                                            {{ festival.soldQuantity | number: '1.0-0' : 'hu-HU' }}
                                                        </div>
                                                        <div class="product-statistic__grid-cell">
                                                            {{ festival.returnedQuantity | number: '1.0-0' : 'hu-HU' }}
                                                        </div>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                }
                            </div>
                        }
                    }
                </div>
            </div>
        </div>
        @if (totalItems() > 0) {
            <pf-pagination
                [requestedPage]="page()"
                [requestedPageSize]="size()"
                [totalItems]="totalItems()"
                (pageChanged)="onPageChanged($event)"
            />
        }
        <div class="product-statistic__totals">
            <div class="product-statistic__total-card">
                <mat-icon>print</mat-icon>
                <span>{{ 'admin.product.statistics.total.printed' | translate | uppercase }}</span>
                <div class="product-statistic__total-value">{{ totals()?.printed ?? 'N/A' }}</div>
            </div>
            <div class="product-statistic__total-card">
                <mat-icon>shopping_cart</mat-icon>
                <span>{{ 'admin.product.statistics.total.sold' | translate | uppercase }}</span>
                <div class="product-statistic__total-value">{{ totals()?.sold ?? 'N/A' }}</div>
            </div>
            <div class="product-statistic__total-card">
                <mat-icon>business</mat-icon>
                <span>{{ 'admin.product.statistics.total.office' | translate | uppercase }}</span>
                <div class="product-statistic__total-value">{{ totals()?.office ?? 'N/A' }}</div>
            </div>
            <div class="product-statistic__total-card">
                <mat-icon>warehouse</mat-icon>
                <span>{{ 'admin.product.statistics.total.warehouse' | translate | uppercase }}</span>
                <div class="product-statistic__total-value">{{ totals()?.warehouse ?? 'N/A' }}</div>
            </div>
            <div class="product-statistic__total-card">
                <mat-icon>language</mat-icon>
                <span>{{ 'admin.product.statistics.total.soldViaWebshop' | translate | uppercase }}</span>
                <div class="product-statistic__total-value">{{ totals()?.webSales ?? 'N/A' }}</div>
            </div>
            <div class="product-statistic__total-card">
                <mat-icon>local_shipping</mat-icon>
                <span>{{ 'admin.product.statistics.total.stayedInDelegation' | translate | uppercase }}</span>
                <div class="product-statistic__total-value">{{ totals()?.stayedInDelegation ?? 'N/A' }}</div>
            </div>
        </div>
    }
</div>
